import { CHAT_API_URL } from "../../redux/constants/type";

export function resolveNotificationAvatarUrl(value) {
  const avatar = value ? String(value).trim() : "";

  if (!avatar) {
    return "";
  }

  if (/^https?:\/\//i.test(avatar) || avatar.startsWith("data:")) {
    return avatar;
  }

  if (avatar.startsWith("/")) {
    return `${CHAT_API_URL}${avatar}`;
  }

  return avatar;
}
